const Noodl = require('@noodl/noodl-sdk');
const React = require('react');
const { ProjectCard } = require('@prodikt/ui');

module.exports = Noodl.defineReactNode({
	name: 'Prodikt Project Card',
	category: 'Prodikt Views',
	getReactComponent() {
		return ProjectCard;
	},
	inputProps: {
		// Required
		id: {
			type: 'string',
			displayName: 'Project ID',
			group: 'General'
		},
		name: {
			type: 'string',
			displayName: 'Name',
			group: 'General'
		},
		updatedAt: {
			type: 'string',
			displayName: 'Updated At',
			group: 'General'
		},

		// Optional Details
		client: {
			type: 'string',
			displayName: 'Client',
			group: 'Details'
		},
		size: {
			type: 'number',
			displayName: 'Size (mÂ²)',
			group: 'Details'
		},
		location: {
			type: 'object',
			displayName: 'Location',
			group: 'Details'
		},
		image: {
			type: 'object',
			displayName: 'Image',
			group: 'Details'
		},

		// Project Type
		type: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Private', value: 0 },
					{ label: 'Team', value: 1 },
					{ label: 'Team Editing', value: 2 }
				]
			},
			displayName: 'Type',
			default: 0,
			group: 'General'
		},

		// Labels
		labels: {
			type: 'array',
			displayName: 'Labels',
			group: 'Details'
		},

		// Not Entered Text
		notEntered: {
			type: 'string',
			displayName: 'Not Entered Text',
			default: '',
			group: 'Details'
		},

		// Menu
		menuActions: {
			type: 'array',
			displayName: 'Menu Actions',
			group: 'Menu'
		}
	},
	outputProps: {
		onClick: {
			type: 'signal',
			displayName: 'Clicked'
		},
		projectId: {
			type: 'string',
			displayName: 'Project ID'
		},
		onMenuAction: {
			type: 'signal',
			displayName: 'Menu Action'
		},
		actionId: {
			type: 'string',
			displayName: 'Action ID'
		}
	},
	setup: function(context, graphModel) {
		if (!context.propsInput) context.propsInput = {};
	},
	initialize: function() {
		// Set up onClick handler
		this.props.onClick = () => {
			const projectId = this.inputs.id;
			this.setOutputs({ projectId });
			this.sendSignalOnOutput('onClick');
		};

		// Set up onMenuAction handler
		this.props.onMenuAction = (projectId, actionId) => {
			this.setOutputs({ projectId, actionId });
			this.sendSignalOnOutput('onMenuAction');
		};
	}
});
